import Image from "next/image";
import { Card } from "@/components/ui/card";

export interface DoubleCardAuthProps {
  leftElement: React.ReactNode;
  rightElement?: React.ReactNode;
  topRightImage?: {
    src: string;
    alt: string;
  };
}
export default function DoubleCardAuth({
  leftElement,
  rightElement,
  topRightImage,
}: DoubleCardAuthProps) {
  return (
    <>
      <div
        className={`hidden lg:flex relative ${
          rightElement ? "w-full lg:w-full xl:w-9/12 2xl:w-8/12" : "w-[520px] mx-auto"
        }`}
      >
        {topRightImage && (
          <Image
            alt={topRightImage.alt}
            className={`absolute -top-36 z-31 ${rightElement ? "-right-4" : "-right-12"}`}
            src={topRightImage.src}
          />
        )}
        <div className="absolute -bottom-[124px] -left-[80px] w-[220px] h-[220px] bg-deformed-shape-and-two-glass-balls bg-contain bg-no-repeat pointer-events-none" />
        <Card className={rightElement ? "w-1/2 z-10 shadow-small" : "z-10 shadow-small w-[520px] "}>
          {leftElement}
        </Card>
        {rightElement && (
          <Card className="-ml-4 pl-4" style={{ width: "calc(50% + 16px)" }}>
            {rightElement}
          </Card>
        )}
      </div>
      <div className="lg:hidden w-full h-full">{leftElement}</div>
    </>
  );
}
